'use client';
import styles from './slider2.module.scss';
//import * as motion from 'framer-motion/client';
import Image from 'next/image';
import classNames from 'classnames';
import { motion } from 'framer-motion';

// import { useState, useEffect } from 'react';

const SliderPage2 = () => {
    const sliderImage = (row, number, lazyLoad) => {
        return (
            <div className={styles.sliderImageComp}>
                <Image
                    alt={`${number}-image`}
                    fill
                    placeholder='blur'
                    blurDataURL='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAIAAAD/gAIDAAAA60lEQVR4nO3QQQ3AIADAQEDXFCEHxbOwvsiSOwVN59nP4Jt1O+BPzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCswKzArMCl64vQIAH7NZWwAAAABJRU5ErkJggg=='
                    src={`/src/landing/slider/${row}/${number}.jpg`}
                    quality={75}
                    {...(lazyLoad ? { loading: 'lazy' } : {})}
                />
            </div>
        );
    };

    return (
        <motion.div
            initial={{ y: '100%' }}
            animate={{ y: '0' }}
            transition={{ delay: 0.75, duration: 1, ease: 'linear' }}
            id='#section2'
            className={styles.sliderWrapper}
        >
            <motion.div
                className={classNames(styles.row, styles.firstRow)}
                // style={width > 2000 || width < 1024 ? { x: firstLarge } : { x: first }}
            >
                <div>
                    {sliderImage(1, 0, true)}
                    {sliderImage(1, 1, true)}
                    {sliderImage(1, 2, true)}
                    {sliderImage(1, 3, true)}
                    {sliderImage(1, 4, true)}
                    {sliderImage(1, 5, true)}
                    {sliderImage(1, 6, true)}
                    {sliderImage(1, 7, true)}
                    {sliderImage(1, 0, true)}
                    {sliderImage(1, 1, true)}
                    {sliderImage(1, 2, true)}
                    {sliderImage(1, 3, true)}
                    {sliderImage(1, 4, true)}
                    {sliderImage(1, 5, true)}
                    {sliderImage(1, 6, true)}
                    {sliderImage(1, 7, true)}
                </div>
            </motion.div>
            <motion.div
                className={classNames(styles.row, styles.secondRow)}
                // style={width > 2000 || width < 1024 ? { x: secondLarge } : { x: second }}
            >
                <div>
                    {/*{sliderImage(2, 8)}*/}
                    {sliderImage(2, 9)}
                    {sliderImage(2, 10)}
                    {sliderImage(2, 11)}
                    {sliderImage(2, 12)}
                    {sliderImage(2, 13)}
                    {sliderImage(2, 14)}
                    {sliderImage(2, 15)}
                    {/*{sliderImage(2, 16)}*/}
                    {/*{sliderImage(2, 8)}*/}
                    {sliderImage(2, 9)}
                    {sliderImage(2, 10)}
                    {sliderImage(2, 11)}
                    {sliderImage(2, 12)}
                    {sliderImage(2, 13)}
                    {sliderImage(2, 14)}
                    {sliderImage(2, 15)}
                    {/*{sliderImage(2, 16)}*/}
                </div>
            </motion.div>
            <motion.div
                className={classNames(styles.row, styles.thirdRow)}
                // style={width > 2000 || width < 1024 ? { x: thirdLarge } : { x: third }}
            >
                <div>
                    {sliderImage(3, 17)}
                    {sliderImage(3, 18)}
                    {sliderImage(3, 19)}
                    {sliderImage(3, 20)}
                    {sliderImage(3, 21)}
                    {sliderImage(3, 22)}
                    {sliderImage(3, 23)}
                    {sliderImage(3, 24)}
                    {sliderImage(3, 17)}
                    {sliderImage(3, 18)}
                    {sliderImage(3, 19)}
                    {sliderImage(3, 20)}
                    {sliderImage(3, 21)}
                    {sliderImage(3, 22)}
                    {sliderImage(3, 23)}
                    {sliderImage(3, 24)}
                </div>
            </motion.div>
        </motion.div>
    );
};
export default SliderPage2;
